import * as React from 'react';
import cls from 'classnames';
import { Markdown } from 'src/explore/elements/Markdown';

import styles from './index.module.sass';

interface Props {
  className?: string;
  containerElement?: React.ElementType;
  inline?: boolean;
  standardFormatting?: boolean;
  style?: React.CSSProperties;
}

export const EditorContent: React.FC<Props> = ({
  children,
  className,
  containerElement,
  inline = false,
  standardFormatting,
  ...props
}) => {
  if ( !children ) return null;

  const isMarkdown = typeof children === 'string';

  let Container = isMarkdown ? Markdown : containerElement;
  if ( !Container ) {
    Container = Container || inline ? 'span' : 'div';
  }

  return (
    <Container
      className={cls( className, styles.markdown, { [styles.formatted]: standardFormatting })}
      {...props}
    >
      {children}
    </Container>
  );
};
